import Header from "../../../shared/app-shell/Header";
import Sidebar from "../../../shared/app-shell/Sidebar";
import { themeAtom } from "../../../shared/atoms";
import VesselSearcherFiltersPanel from "../components/VesselSearcherFilters";
import VesselSearcherTable from "../components/VesselSearcherTable";
import { useVesselSearcher } from "../hooks/useVesselSearcher";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

// Recreates the single-page Vessel Searcher report while keeping source selection and requests inside its own module.
const VesselSearcherPage = () => {
  const theme = useAtomValue(themeAtom);
  const state = useVesselSearcher();
  const filterOptions = state.response?.filterOptions ?? { engineTypes: [], designs: [], yards: [], countries: [] };

  return (
    <div className="flex h-screen" data-test="vessel-searcher-page">
      <Sidebar />
      <div className={twMerge("flex min-w-0 flex-1 flex-col overflow-hidden", theme.home.tailwind.backgound, theme.home.tailwind.textDefault)}>
        <Header />
        <main className="flex min-h-0 flex-1 flex-col overflow-hidden px-4 pb-5 pt-3 sm:px-6">
          <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-3"><div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-20 text-green dark:bg-teal-900/50"><MagnifyingGlassIcon className="h-6 w-6" /></div><div><p className="text-xs font-semibold uppercase tracking-[0.12em] text-green">Fleet intelligence</p><h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100 sm:text-2xl">Vessel Searcher</h1></div></div>
            <div className="rounded-xl border border-primary-20 bg-primary-10 px-4 py-2 text-right dark:border-teal-800 dark:bg-teal-950/40"><p className="text-lg font-semibold leading-5 text-green">{(state.response?.total ?? 0).toLocaleString("en-US")}</p><p className="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">Vessels</p></div>
          </div>
          <div className="grid min-h-0 flex-1 items-stretch gap-4 lg:grid-cols-[260px_minmax(0,1fr)]">
            <VesselSearcherFiltersPanel filters={state.filters} options={filterOptions} useMockData={state.useMockData} activeRangeFilters={state.activeRangeFilters} onChange={state.setFilters} onClear={state.clearFilters} />
            <VesselSearcherTable response={state.response} isLoading={state.isLoading} error={state.error} useMockData={state.useMockData} offset={state.offset} pageSize={state.pageSize} sortBy={state.sortBy} sortDirection={state.sortDirection} onSort={state.setSort} onOffsetChange={state.setOffset} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default VesselSearcherPage;
